import typeOf from '../utilities/typeOf';
import Component from './Component';
import { toggleOverlay } from '../services/ScrollResizeHandler';

/**
 * --------------------------------------------------------------------------------------------
 * PRIVATE VARIABLES
 * --------------------------------------------------------------------------------------------
 */

 const TIMING = 350;



/**
 * --------------------------------------------------------------------------------------------
 * HELPER FUNCTIONS
 * --------------------------------------------------------------------------------------------
 */







/**
 * --------------------------------------------------------------------------------------------
 * EXPORTS
 * --------------------------------------------------------------------------------------------
 */



export default class Modal extends Component {

    decorator () {
        return {
            selector : '.js-modal',
            name : 'Modal',
        }
    }


    constructor(element) {
        super(element);

        // INITIAL CALLS
        this.cacheElements();
    }


    cacheElements () {
        this.$overlay = document.querySelector('.js-overlay')
        this.$content = this.element.querySelector('.js-modal-content');
        this.$close = this.element.querySelector('.js-modal-close');
    }


    cacheData () {
        this.visible = false;
    }


    bindEvents () {
        this.$close.addEventListener('click', e => {e.preventDefault(); this.close();});
        this.$overlay.addEventListener('click', e => this.close());
    }


    open (tempName, cb) {

        if (this.visible) { return; }
        // clear content
        this.clearContent();
        // toggle overlay
        toggleOverlay();
        // pass the template name
        // get its content
        this.insertData(tempName);

        this.element.classList.add('is-active');

        setTimeout(()=> {
            this.element.classList.add('is-visible')
        }, TIMING);


        if (typeOf(cb).is(Function)) {
            cb.call(this);
        }

        //
        this.visible = true;

        this.bindEvents();
    }


    close (cb) {

        if (!this.visible) { return; }

        this.element.classList.remove('is-visible');

        setTimeout(() => {
            toggleOverlay();
            this.element.classList.remove('is-active');
            // clear content before closing the modal
            this.clearContent();

            if (typeOf(cb).is(Function)) {
                cb.call(this);
            }
        }, TIMING);

        this.visible = false;
    }


    insertData (tempName) {
        let _name = tempName;
        this.$content.innerHTML = document.querySelector('#' + _name).innerHTML;
    }


    clearContent () {
        this.$content.innerHTML = '';
    }

}
